import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "items-center" }
const _hoisted_2 = ["for"]
const _hoisted_3 = {
  key: 0,
  class: "text-red-500 ml-auto flex place-items-center"
}
const _hoisted_4 = ["value", "max", "placeholder", "autocomplete", "readonly"]
const _hoisted_5 = ["value", "type", "id", "placeholder", "autocomplete", "disabled", "readonly"]
const _hoisted_6 = ["v-model", "type", "id", "max", "placeholder", "autocomplete", "disabled", "readonly"]
const _hoisted_7 = {
  key: 6,
  class: "text-xs italic min-h-[16px]"
}

import { computed, PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TextField',
  props: {
  name: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    required: false,
  },
  type: {
    type: String,
    required: true,
  },
  placeholder: {
    type: String,
    required: false,
  },
  model: {
    type: [Number, String, null] as PropType<number | string | null>,
    default: null,
    required: false,
  },
  modelFile: {
    type: [File],
    required: false,
  },
  errorMessage: {
    type: String,
    default: "",
  },
  infoMessage: {
    type: String,
    default: "",
  },
  hasError: {
    type: Boolean,
    default: false,
  },
  hideDetails: {
    type: Boolean,
    default: false,
  },
  hideInfo: {
    type: Boolean,
    default: false,
  },
  iconName: {
    type: String,
    required: false,
  },
  autocomplete: {
    type: String,
    required: false,
  },
  isAcopled: {
    type: Boolean,
    required: false,
    default: false,
  },
  compact: {
    type: Boolean,
    required: false,
    default: false,
  },
  disabled: {
    type: Boolean,
    required: false,
    default: false,
  },
  readonly: {
    type: Boolean,
    required: false,
    default: false,
  },
  step: {
    type: Number,
    require: false,
    default: undefined,
  },
  max: {
    type: Number,
    required: false,
    default: 255,
  },
},
  emits: ["update:model", "update:modelFile"],
  setup(__props, { emit }) {

const props = __props;





const errorMessageStyle = computed(() =>
  props.hasError ? "" : "visibility: hidden"
);

function updateModel(event: Event) {
  if (event.target === null) return;

  if (props.type == "number")
    emit("update:model", Number((event.target as HTMLInputElement).value));
  if (props.type == "file")
    emit("update:modelFile", (event.target as HTMLInputElement).files?.item(0));
  if (props.type != "file" && props.type != "number")
    emit("update:model", (event.target as HTMLInputElement).value);
}

return (_ctx: any,_cache: any) => {
  const _component_mdicon = _resolveComponent("mdicon")!
  const _component_Popper = _resolveComponent("Popper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          class: _normalizeClass(["flex text-sm font-semibold pb-1", {
        'text-red-500': __props.hasError,
        'text-gray-700': !__props.hasError,
      }]),
          for: __props.name
        }, [
          _createTextVNode(_toDisplayString(__props.label) + " ", 1),
          (__props.hideDetails && __props.hasError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_Popper, {
                  arrow: "",
                  class: "font-normal",
                  placement: "auto",
                  hover: "",
                  content: __props.errorMessage
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_mdicon, {
                      name: "error",
                      size: "16"
                    })
                  ]),
                  _: 1
                }, 8, ["content"])
              ]))
            : _createCommentVNode("", true)
        ], 10, _hoisted_2))
      : _createCommentVNode("", true),
    (__props.iconName)
      ? (_openBlock(), _createBlock(_component_mdicon, {
          key: 1,
          class: "absolute ml-2 my-2",
          size: "20",
          name: __props.iconName
        }, null, 8, ["name"]))
      : _createCommentVNode("", true),
    (__props.type == 'textarea')
      ? (_openBlock(), _createElementBlock("textarea", {
          key: 2,
          class: _normalizeClass(["appearance-none border rounded w-full py-2 px-2 leading-tight focus:outline-none hover:border-gray-400", {
        'text-gray-700 border-gray-300 focus:border-black': !__props.hasError,
        'text-red-700 border-red-300 focus:border-red-400': __props.hasError,
        'text-gray-400 border-gray-300 focus:border-gray-400': __props.readonly,
      }]),
          value: __props.model as string,
          max: __props.max,
          onInput: updateModel,
          placeholder: __props.placeholder,
          autocomplete: __props.autocomplete,
          rows: "4",
          readonly: __props.readonly
        }, null, 42, _hoisted_4))
      : _createCommentVNode("", true),
    (__props.type != 'textarea' && __props.type != 'file')
      ? (_openBlock(), _createElementBlock("input", {
          key: 3,
          class: _normalizeClass([{
        'p-1 text-sm': __props.compact,
        'p-2': !__props.compact,
        'pl-8': __props.iconName,
        'border-r border-y rounded rounded-l-none': __props.isAcopled,
        'border rounded': !__props.isAcopled,
        'text-gray-700 border-gray-300 focus:border-black': !__props.hasError,
        'text-red-700 border-red-300 focus:border-red-400': __props.hasError,
        'text-gray-400 border-gray-300 focus:border-gray-300': __props.readonly,
      }, "appearance-none w-full leading-tight focus:outline-none disabled:border-gray-200 disabled:text-gray-200 placeholder:text-sm px-4"]),
          value: __props.model,
          onInput: updateModel,
          type: __props.type,
          id: __props.name,
          placeholder: __props.placeholder,
          autocomplete: __props.autocomplete,
          disabled: __props.disabled,
          readonly: __props.readonly
        }, null, 42, _hoisted_5))
      : _createCommentVNode("", true),
    (__props.type == 'file')
      ? (_openBlock(), _createElementBlock("input", {
          key: 4,
          class: _normalizeClass([{
        'p-1 text-sm': __props.compact,
        'p-2': !__props.compact,
        'pl-8': __props.iconName,
        'border-r border-y rounded rounded-l-none': __props.isAcopled,
        'border rounded': !__props.isAcopled,
        'text-gray-700 border-gray-300 focus:border-black': !__props.hasError,
        'text-red-700 border-red-300 focus:border-red-400': __props.hasError,
      }, "appearance-none w-full leading-tight focus:outline-none disabled:border-gray-200 disabled:text-gray-200"]),
          "v-model": __props.modelFile,
          onInput: updateModel,
          type: __props.type,
          id: __props.name,
          max: __props.max,
          placeholder: __props.placeholder,
          autocomplete: __props.autocomplete,
          disabled: __props.disabled,
          readonly: __props.readonly
        }, null, 42, _hoisted_6))
      : _createCommentVNode("", true),
    (!__props.hideDetails)
      ? (_openBlock(), _createElementBlock("p", {
          key: 5,
          class: "text-red-500 text-xs italic min-h-[16px]",
          style: _normalizeStyle(errorMessageStyle.value)
        }, _toDisplayString(__props.errorMessage), 5))
      : _createCommentVNode("", true),
    (__props.hideInfo)
      ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(__props.infoMessage), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})